import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const TopBar = (props) => {
     const {projectData,navigate} = props;
     const navigatePage = useNavigate();
    //  console.log(projectData)
  return (
    <div className="top-bar">
       <div className={window.innerWidth > 750 ? "page-header-style" : "page-header-data-style"}>
              <div className={window.innerWidth > 750 ? "project-title" : "project-title-mob"}>
               <ArrowLeftOutlined style={{ color: "#fff", fontSize: "36px", margin: "0px 10px" }} onClick={() => window.innerWidth > 750 ? navigatePage(navigate) : navigatePage(navigate)} />
                <div className="title">
                  {projectData?.TopicDesc || projectData?.topicdesc}
                </div>
              </div>
            </div>
    </div>
  )
}
export default TopBar;

